import React from 'react'
import * as R from 'ramda'

import { AtsLockContext } from 'components/common/AtsLock'
import { Pane } from 'components/shared/Pane/Pane'

import { useJobDetails } from './hooks'
import { getTab } from './model'

import styles from './JobDetails.module.scss'

export const JobDetails = () => {
  const { state, handlers } = useJobDetails()

  const {
    activeTab,
    project,
    tabs,
    hasInterviewModule,
    hasInterviewTemplate,
    isInterviewAvailable,
  } = state
  const { handleTabChange } = handlers

  const { owner_ats } = project ?? {}

  const tab = getTab({
    activeTab,
    project,
    hasInterviewModule,
    hasInterviewTemplate,
    isInterviewAvailable,
  })

  const isAtsLocked = owner_ats ? R.T() : R.F()

  const context = React.useMemo(
    () => ({
      owner: owner_ats,
      isAtsLocked,
    }),
    [owner_ats, isAtsLocked],
  )

  return (
    <Pane className={styles.details}>
      <Pane.TabsBar
        tabClassName={styles.tab}
        onClick={handleTabChange}
        {...{ activeTab, tabs }}
      />
      <AtsLockContext.Provider value={context}>{tab}</AtsLockContext.Provider>
    </Pane>
  )
}
